export const cssVars = {
    backgroundColor: 'background-color',
    borderColor: 'border-color',
    borderRadius: 'border-radius',
    borderWidth: 'border-width',
    foregroundColor: 'foreground-color',
    textColor: 'color',
    fillColor: 'fill-color',
    strokeColor: 'stroke-color',
    iconColor: 'icon-color',
};
export const styleStates = ['hover', 'disabled'];
export const styleStateCssVars = {
    hover: {
        textColor: 'hover-color',
        borderColor: 'hover-border-color',
        backgroundColor: 'hover-background-color',
        iconColor: 'hover-icon-color',
    },
    disabled: {
        textColor: 'disabled-color',
        borderColor: 'disabled-border-color',
        backgroundColor: 'disabled-background-color',
        iconColor: 'disabled-icon-color',
    },
};
//# sourceMappingURL=constants.js.map